import Logger from 'common/logger'

const logger = new Logger('EVENT_SOURCE')

/**
 * Fired on `window` when an `EventSource` (the event's `detail`) delivered
 * data it could not parse. Events have arrived glued together under load, so
 * the stream has lost at least one event and no longer holds the room's
 * state; whoever owns the stream reconnects, and the server sends the state
 * afresh.
 */
export const CORRUPT_STREAM_EVENT = 'beelday:corrupt-stream'

export function jsonEventHandler<T>(handler: (data: T) => void): EventListener {
	return ((message: MessageEvent) => {
		let data
		try {
			data = JSON.parse(message.data)
		} catch (error) {
			// A warning: the stream's owner reconnects and nothing is lost.
			logger.warn('Unreadable SSE event, reconnecting', error, message)
			window.dispatchEvent(
				new CustomEvent(CORRUPT_STREAM_EVENT, { detail: message.target })
			)
			return
		}

		try {
			handler({
				...data,
				timestamp: new Date(data.timestamp),
			})
		} catch (error) {
			logger.error('Error handling SSE event', error, message)
			throw error
		}
	}) as EventListener
}
